const toolbar = [
  'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote undo redo removeformat subscript superscript code',
  'hr bullist numlist link image charmap preview anchor pagebreak media table emoticons forecolor backcolor fullscreen fontsizeselect styleselect']

export default toolbar
